import { render } from "./Link.vue?vue&type=template&id=5ef496d6"
import script from "./Link.vue?vue&type=script&lang=ts"
export * from "./Link.vue?vue&type=script&lang=ts"
script.render = render

export default script